import type { StatusLedMapping, ValueTileWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  ColourField,
  ListEditor,
  NumberField,
  Row,
  ScalarField,
  Section,
  TextField,
  formatScalar,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Value tile. Unit and decimals only when they should differ from the
 *  leaf; empty means "as the leaf says". */
export function ValueTileEditor(
  { widget, plantId, onChange }: WidgetEditorProps<ValueTileWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Wert-Datenpunkt"
          value={widget.valuePoint}
          plantId={plantId}
          onChange={(next) => patch({ valuePoint: next })}
        />
      </Section>
      <Section title="Anzeige">
        <Row>
          <TextField
            label="Einheit"
            value={widget.unit}
            placeholder="wie Datenpunkt"
            onChange={(next) => patch({ unit: next })}
          />
          <NumberField
            label="Nachkommastellen"
            value={widget.decimals ?? undefined}
            min={0}
            max={4}
            integer
            hint="Leer = wie im Datenpunkt."
            onChange={(next) => patch({ decimals: next })}
          />
        </Row>
        <CheckboxField
          label="Alter des Werts anzeigen"
          checked={widget.showAge !== false}
          onChange={(next) => patch({ showAge: next })}
        />
      </Section>
      <Section title="Farbe je Wert (optional)">
        <ListEditor<StatusLedMapping>
          label="Wert zu Farbe"
          items={widget.mapping ?? []}
          addLabel="Zuordnung"
          emptyHint="Ohne Zuordnung färben die Warn- und Alarmgrenzen des Datenpunkts die Zahl."
          create={() => ({ value: undefined, colour: '#62c26e' })}
          itemTitle={(m, i) => m.label || formatScalar(m.value) || `Zeile ${i + 1}`}
          onChange={(next) => patch({ mapping: next.length > 0 ? next : undefined })}
          renderItem={(entry, patchEntry) => (
            <>
              <Row>
                <ScalarField
                  label="Wert"
                  value={entry.value}
                  required
                  onChange={(next) => patchEntry({ value: next })}
                />
                <ColourField
                  label="Farbe"
                  value={entry.colour}
                  onChange={(next) => patchEntry({ colour: next ?? '' })}
                />
              </Row>
              <TextField
                label="Ersatztext"
                value={entry.label}
                placeholder="Kein Fehler"
                onChange={(next) => patchEntry({ label: next })}
              />
            </>
          )}
        />
      </Section>
    </>
  );
}
